import React from 'react';
// import './Newsletter.css'; // Importing the custom CSS

const NewsLetter = () => {
    return (
        <div className="row newsletter-section">
            <div className="col-12 text-center">
                <div className="subscription-form container">
                    <h3 className="d-flex justify-content-center align-items-center mb-4">
                        <img src="images/envelope-outline.svg" alt="Envelope" className="me-2 icon" />
                        <span>Subscribe to our Newsletter</span>
                    </h3>

                    <form action="#" className="row g-3 justify-content-center">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Enter your name" />
                        </div>
                        <div className="col-md-3">
                            <input type="email" className="form-control" placeholder="Enter your email" />
                        </div>
                        <div className="col-md-2">
                            <button type="submit" className="btn btn-primary w-100">
                                Subscribe
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewsLetter;
